import React, { useEffect, useRef, useState } from "react";
import Logo from "../../assets/img/header-logo.png";
import "animate.css"; // Ensure Animate.css is imported

const LastWorkedOn = () => {
  const raw = process.env.REACT_APP_BUILD_DATE;
  const timestampSeconds = Number(raw);

  if (!raw || !Number.isFinite(timestampSeconds) || timestampSeconds <= 0) {
    return <span>website last updated on --/--/----</span>;
  }

  const buildDate = new Date(timestampSeconds * 1000);
  const formattedDate = buildDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return <span>website last updated on {formattedDate}</span>;
};

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  const handleScroll = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsVisible(true); // Set to true when the section is visible
      } else {
        setIsVisible(false); // Set to false when the section is not visible
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleScroll, {
      threshold: 0.1, // Adjust threshold as needed
    });
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className="row bg-white" ref={ref}>
      <div className="col-12 container">
        <div className="row px-5 py-3 align-items-center justify-content-center justify-content-lg-between">
          <div className="col-6">
            <img
              src={Logo}
              alt="Regent Dental Logo"
              height="80"
              className={`animate__animated ${
                isVisible ? "animate__bounceIn" : "animate__bounceOut"
              }`}
            />
          </div>
          <div className="col-6 d-flex align-items-center justify-content-end px-5">
            <p
              className={`mb-0 d-flex align-items-center text-dark animate__animated ${
                isVisible ? "animate__bounceIn" : "animate__bounceOut"
              }`}>
              <span className="text-golden fs-20 d-none d-lg-block">
                {" "}
                Follow Us{" "}
              </span>{" "}
              &nbsp;&nbsp;
              <i className="fa fa-facebook me-2" aria-hidden="true"></i>
              &nbsp;&nbsp;
              <a
                href="https://www.instagram.com/regentdental_ilkley/"
                className="text-dark"
                target="_blank">
                <i className="fa fa-instagram" aria-hidden="true"></i>
              </a>
            </p>
          </div>
          <div className="col-12 border mt-3"></div>
          <div className="col-12">
            <div className="text-center text-dark mt-3">
              <p
                className={`mb-0 fs-11 footer-bottom animate__animated ${
                  isVisible ? "animate__bounceIn" : "animate__bounceOut"
                }`}>
                © {new Date().getFullYear()} Regent Dental. All Rights
                Reserved. <br />
                <a
                  href="/privacy-policy"
                  className="text-dark text-decoration-none">
                  {" "}
                  Privacy & Cookie Policy{" "}
                </a>{" "}
                |{" "}
                <a
                  href="/terms-of-use"
                  className="text-dark text-decoration-none">
                  {" "}
                  Terms of Use
                </a>{" "}
                |{" "}
                <a
                  href="https://www.cqc.org.uk/"
                  target="_blank"
                  className="text-dark text-decoration-none">
                  CQC
                </a>{" "}
                |{" "}
                <a
                  href="https://www.gdc-uk.org/"
                  target="_blank"
                  className="text-dark text-decoration-none">
                  GDC
                </a>{" "}
                |{" "}
                <a
                  href="/complain-policy"
                  className="text-dark text-decoration-none">
                  Complaints Policy
                </a>
                <br />
                designed and maintained by{" "}
                <a
                  className="text-dark text-decoration-none"
                  href="https://www.dentopia.marketing/"
                  target="_blank">
                  {" "}
                  dentopia marketing{" "}
                </a>{" "}
                <br />
                <LastWorkedOn /> <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
